import BaseLineClamp from "./BaseLineClamp.vue";

export * from "./BaseLineClamp.vue";
export default BaseLineClamp;
